import XponentialPlusModule from "./xponentialPlusModule";
import XponentialPlusSagas from "./redux/xponentialPlusSagas";
import XponentialPlusReducer from "./redux/xponentialPlusReducer";

export default {
  Component: XponentialPlusModule,
  moduleName: "xponentialPlus",
  saga: XponentialPlusSagas(),
  reducer: XponentialPlusReducer
};
